import "./polyfills";
import * as Pages from "./pages";

Object.keys(Pages).forEach((key) => Pages[key]());
